// extracted by mini-css-extract-plugin
export var text = "_br-0";